export interface CharacterItem {
  id: string;
  name: string;
  role: string;
  avatar: string;
  summary: string;
  keywords: string[];
}

export interface EpisodeItem {
  id: number;
  phase: string;
  title: string;
  duration: string;
  summary: string;
  tags: string[];
}

export interface HighlightItem {
  id: string;
  time: string;
  title: string;
  desc: string;
  image: string;
}

export interface ArcItem {
  id: string;
  title: string;
  range: string;
  lead: string;
  points: string[];
}

export interface ReviewItem {
  id: string;
  user: string;
  badge: string;
  text: string;
}

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export interface RelatedItem {
  id: string;
  title: string;
  genre: string;
  episodes: string;
  poster: string;
  blurb: string;
}

export interface StatItem {
  id: string;
  label: string;
  value: string;
  note: string;
}

export const dramaMeta = {
  name: '漂亮的小姨子',
  tagline: '一部围绕亲情、误会与成长展开的家庭情感短剧',
  updatedTo: '第 42 集 · 大结局',
  updateNote: '全集已上线，可直接一口气看完',
  summary:
    '《漂亮的小姨子》以一次意外的同住为起点，讲述姐夫陆承与小姨子苏念在同一屋檐下从彼此戒备到相互理解的过程。姐姐苏晚的病情、家庭旧账与一场被误读的聚会，把三个人的关系推向风口浪尖。短剧以快节奏推进、强反转和细腻的情感刻画见长，既能看到爽感十足的对峙，也能看到平凡生活里的和解与成长。',
  tags: ['家庭情感', '都市逆袭', '误会反转', '治愈成长', '短剧'],
};

export const heroStats: StatItem[] = [
  { id: 's1', label: '全集进度', value: '42 集', note: '含大结局' },
  { id: 's2', label: '单集时长', value: '2–4 分钟', note: '适合碎片观看' },
  { id: 's3', label: '主要篇章', value: '4 个', note: '相遇 / 同住 / 风波 / 结局' },
  { id: 's4', label: '核心角色', value: '6 位', note: '构成主要关系网' },
];

export const characters: CharacterItem[] = [
  {
    id: 'c1',
    name: '苏念',
    role: '小姨子 · 故事核心',
    avatar:
      'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20cheerful%20young%20Chinese%20woman%20in%20a%20soft%20cream%20sweater%2C%20warm%20golden%20window%20light%2C%20gentle%20smile%2C%20clean%20neutral%20beige%20studio%20background%2C%20editorial%20film%20still%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20warm%20amber%20tones&width=600&height=600&seq=drama-cast-sunian&orientation=squarish',
    summary:
      '刚毕业、直率机灵的大学生。带着自己的倔强住进姐姐家，一边找工作一边照顾姐姐。她的跳脱与直接常被误读为莽撞，却在关键时刻成为推动真相浮出水面的关键。',
    keywords: ['直率', '行动派', '成长线'],
  },
  {
    id: 'c2',
    name: '陆承',
    role: '姐夫 · 沉稳隐忍',
    avatar:
      'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20calm%20composed%20Chinese%20man%20in%20his%20thirties%20wearing%20a%20dark%20knit%20sweater%2C%20soft%20side%20lighting%2C%20thoughtful%20expression%2C%20muted%20warm%20charcoal%20background%2C%20editorial%20film%20still%2C%20shallow%20depth%20of%20field%2C%20cinematic%20color%20grade&width=600&height=600&seq=drama-cast-lucheng&orientation=squarish',
    summary:
      '把情绪藏在细节里的人。白天处理公司危机，晚上默默照看家里。他不擅长解释，于是误会越积越深；属于他的人物弧光，是学会把心里的话说出口。',
    keywords: ['内敛', '责任感', '沉默反差'],
  },
  {
    id: 'c3',
    name: '苏晚',
    role: '姐姐 · 温柔坚韧',
    avatar:
      'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20gentle%20elegant%20Chinese%20woman%20with%20soft%20wavy%20hair%2C%20wearing%20a%20pale%20ivory%20blouse%2C%20warm%20diffused%20daylight%2C%20tender%20serene%20expression%2C%20soft%20cream%20background%2C%20editorial%20film%20still%20aesthetic%2C%20muted%20warm%20tones&width=600&height=600&seq=drama-cast-suwan&orientation=squarish',
    summary:
      '家庭的情感中枢。她既是妻子也是姐姐，习惯把所有人的难处都揽到自己身上。她的选择与隐瞒，构成了整部剧最容易被忽略、却最能解释一切的暗线。',
    keywords: ['顾全大局', '隐忍', '情感枢纽'],
  },
  {
    id: 'c4',
    name: '周彦',
    role: '旧识 · 变数制造者',
    avatar:
      'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20confident%20sharp%20Chinese%20man%20in%20a%20tailored%20dark%20coat%2C%20cool%20dramatic%20side%20lighting%2C%20slight%20enigmatic%20smile%2C%20deep%20teal%20shadowed%20background%2C%20editorial%20film%20still%2C%20cinematic%20contrast%2C%20moody%20tone&width=600&height=600&seq=drama-cast-zhouyan&orientation=squarish',
    summary:
      '带着旧日恩怨重新出现的人。他每次登场都会把原本平稳的关系推向新的试探。是反派还是另一种意义上的推动者，剧集把答案留到了最后。',
    keywords: ['亦敌亦友', '悬念', '推进器'],
  },
  {
    id: 'c5',
    name: '陈姨',
    role: '长辈 · 生活质感担当',
    avatar:
      'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20warm%20kind%20elderly%20Chinese%20woman%20with%20silver%20hair%20in%20a%20simple%20wool%20cardigan%2C%20soft%20window%20light%2C%20gentle%20smile%2C%20warm%20beige%20home%20interior%20blurred%20behind%2C%20editorial%20film%20still%2C%20cozy%20amber%20tones&width=600&height=600&seq=drama-cast-chenyi&orientation=squarish',
    summary:
      '邻居长辈，也是全剧的“生活旁白”。她一边张罗着吃穿用度，一边用几句家常话点破年轻人绕不过去的心结，常常在紧张剧情里递上一杯热汤。',
    keywords: ['幽默', '通透', '烟火气'],
  },
  {
    id: 'c6',
    name: '林小满',
    role: '闺蜜 · 情绪出口',
    avatar:
      'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20bubbly%20young%20Chinese%20woman%20with%20short%20bob%20hair%20and%20colorful%20hoop%20earrings%2C%20bright%20playful%20expression%2C%20soft%20coral%20studio%20background%2C%20editorial%20film%20still%2C%20vivid%20warm%20color%20grade&width=600&height=600&seq=drama-cast-linxiaoman&orientation=squarish',
    summary:
      '苏念的大学好友，说话直来直去。每当主角团越绕越乱时，她总能一句话把重点戳出来，承担了剧里大半的轻松桥段和吐槽名场面。',
    keywords: ['直球', '搞笑担当', '神助攻'],
  },
];

export const episodePhases = ['相遇篇', '同住篇', '风波篇', '大结局篇'];

export const episodes: EpisodeItem[] = [
  { id: 1, phase: '相遇篇', title: '意外的入住', duration: '03:12', summary: '一场临时变故让苏念搬进姐姐家，第一次见面就与陆承因为生活习惯起了小摩擦，双方都给对方贴上了标签。', tags: ['初见', '反差'] },
  { id: 2, phase: '相遇篇', title: '一顿没吃完的晚饭', duration: '02:48', summary: '三个人第一次同桌吃饭，苏晚在中间调停，一顿饭吃得各怀心事，也埋下了后续许多误会的伏笔。', tags: ['铺垫', '关系'] },
  { id: 3, phase: '相遇篇', title: '深夜的快递', duration: '03:05', summary: '苏念替姐姐签收了一个神秘包裹，内容让陆承神色骤变。观众第一次意识到，这个家藏着没说出口的事。', tags: ['悬念', '暗线'] },
  { id: 4, phase: '相遇篇', title: '各退一步', duration: '02:36', summary: '两人因为一件小事各让一步，气氛从针锋相对转向试探性合作，苏念也第一次看到陆承不为人知的一面。', tags: ['破冰', '细节'] },
  { id: 5, phase: '同住篇', title: '早餐战争', duration: '02:52', summary: '一个坚持清淡，一个偏爱重口，早餐桌成了新的战场，陈姨的一句调侃让紧张感瞬间化解。', tags: ['生活流', '喜剧'] },
  { id: 6, phase: '同住篇', title: '姐姐的加班夜', duration: '03:18', summary: '苏晚深夜加班未归，两人被迫独处。沉默的客厅里，一段关于过往的对话第一次拉近了彼此距离。', tags: ['独处', '对话'] },
  { id: 7, phase: '同住篇', title: '被误读的短信', duration: '02:44', summary: '陆承手机里的一条信息被苏念看到，她选择替姐姐留意，却没想到这个决定把自己也卷进了漩涡。', tags: ['误会', '升温'] },
  { id: 8, phase: '同住篇', title: '一起搬家什', duration: '03:00', summary: '两人合力把旧书柜搬进储物间，翻出苏晚年轻时的旧照片，一段被小心收起的家庭记忆重新浮现。', tags: ['回忆', '温度'] },
  { id: 9, phase: '同住篇', title: '界限', duration: '02:40', summary: '苏念想在姐姐家拥有自己的空间，一场关于边界感的争执，让她和陆承都开始重新思考家人之间的距离。', tags: ['磨合', '成长'] },
  { id: 10, phase: '风波篇', title: '聚会上的人', duration: '03:26', summary: '一场同学聚会把周彦重新带回众人视线，他轻描淡写的一句话，让饭桌上的气氛瞬间降到冰点。', tags: ['登场', '转折'] },
  { id: 11, phase: '风波篇', title: '被剪辑的视频', duration: '03:14', summary: '一段断章取义的视频在亲戚间流传，苏念百口莫辩，陆承第一次在众人面前做出明确表态。', tags: ['舆情', '站队'] },
  { id: 12, phase: '风波篇', title: '姐姐的坦白', duration: '03:32', summary: '苏晚终于说出瞒了很久的病情与顾虑，两条并行的暗线第一次交汇，先前所有细节都有了新的解释。', tags: ['真相', '高潮'] },
  { id: 13, phase: '风波篇', title: '一场谈判', duration: '03:08', summary: '陆承独自去找周彦摊牌，两人在旧仓库对峙，旧账被一页页翻开，也逼出了他多年不愿面对的愧疚。', tags: ['对峙', '爽感'] },
  { id: 14, phase: '风波篇', title: '各自的沉默', duration: '02:56', summary: '风暴过后家里格外安静，三个人分别用自己的方式消化情绪，观众能清楚看到每个人的转变在发生。', tags: ['留白', '心理'] },
  { id: 15, phase: '大结局篇', title: '该说的话', duration: '03:20', summary: '陆承终于把压在心里的解释讲给苏念听，一次坦诚的长谈让积攒多集的误会找到出口。', tags: ['和解', '坦诚'] },
  { id: 16, phase: '大结局篇', title: '重新的餐桌', duration: '03:02', summary: '同样的饭桌，同样的三个人，气氛却完全不同。陈姨端上热汤，许多不需要说出口的默契都在这一刻完成。', tags: ['呼应', '温暖'] },
  { id: 17, phase: '大结局篇', title: '各奔前程', duration: '03:10', summary: '苏念拿到心仪的工作机会准备搬走，离开与留下之间的选择，让“家人”这个词有了更完整的含义。', tags: ['成长', '抉择'] },
  { id: 18, phase: '大结局篇', title: '漂亮的小姨子', duration: '03:44', summary: '全剧收束：一段关系结束，另一段关系以更成熟的方式开始。片尾把开头的伏笔一一回应，留下温暖的余味。', tags: ['大结局', '闭环'] },
];

export const highlights: HighlightItem[] = [
  {
    id: 'h1',
    time: '第 12 集',
    title: '姐姐的坦白',
    desc: '被藏了整部剧的病情终于说出口，镜头从餐桌慢慢推近，三个人谁都没有先开口，成为全剧讨论度最高的一场戏。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20dining%20table%20scene%20at%20night%20with%20warm%20amber%20pendant%20lamp%20light%2C%20quiet%20emotional%20atmosphere%2C%20Chinese%20modern%20home%20interior%2C%20soft%20shadow%2C%20moody%20film%20still%2C%20shallow%20depth%20of%20field%2C%20red%20and%20gold%20warm%20grade&width=800&height=450&seq=drama-scene-confession&orientation=landscape',
  },
  {
    id: 'h2',
    time: '第 13 集',
    title: '旧仓库的对峙',
    desc: '陆承与周彦正面对峙的一场戏，台词密度极高、节奏紧凑，是全剧“爽感”最强的段落，也补全了多年前那段旧事。',
    image:
      'https://readdy.ai/api/search-image?query=Dramatic%20old%20warehouse%20interior%20at%20dusk%20with%20dusty%20light%20beams%20through%20high%20windows%2C%20two%20silhouettes%20facing%20each%20other%2C%20tense%20atmosphere%2C%20moody%20cinematic%20film%20still%2C%20deep%20green%20and%20warm%20amber%20contrast&width=800&height=450&seq=drama-scene-showdown&orientation=landscape',
  },
  {
    id: 'h3',
    time: '第 6 集',
    title: '客厅里的长谈',
    desc: '深夜的客厅只有一盏台灯亮着，两个本来互相戒备的人第一次平静地说起各自的难处，被观众称为“最不吵却最好哭”的一幕。',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20late%20night%20living%20room%20with%20a%20single%20warm%20table%20lamp%2C%20soft%20beige%20sofa%2C%20quiet%20intimate%20mood%2C%20Chinese%20home%20interior%2C%20gentle%20shadows%2C%20cinematic%20film%20still%2C%20warm%20amber%20color%20grade&width=800&height=450&seq=drama-scene-latenight&orientation=landscape',
  },
  {
    id: 'h4',
    time: '第 18 集',
    title: '片尾的回望',
    desc: '大结局用一组回望镜头把开头与结尾连成闭环，从第一次同住的别扭到最后的坦然，情绪在音乐里被完整收住。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20sunset%20light%20through%20sheer%20curtains%20in%20a%20tidy%20Chinese%20living%20room%2C%20empty%20sofa%20and%20a%20steaming%20cup%20of%20tea%20on%20the%20table%2C%20nostalgic%20hopeful%20mood%2C%20cinematic%20film%20still%2C%20golden%20warm%20grade&width=800&height=450&seq=drama-scene-finale&orientation=landscape',
  },
];

export const arcs: ArcItem[] = [
  {
    id: 'a1',
    title: '相遇篇：两个世界的第一次碰撞',
    range: '第 1–4 集',
    lead: '一切从一次临时搬家开始，误会与善意同时发生。',
    points: [
      '入住第一晚就因生活习惯不同产生摩擦，双方各自在心里给对方贴上标签。',
      '一顿吃得各怀心事的晚饭，把家庭里没说出口的潜台词第一次摆到台面。',
      '神秘包裹的出现，让观众先于主角察觉到这个家藏着旧事。',
      '由针锋相对到各让一步，紧张感里透出第一丝可以被信任的迹象。',
    ],
  },
  {
    id: 'a2',
    title: '同住篇：柴米油盐里的关系升温',
    range: '第 5–9 集',
    lead: '把矛盾放进日常，让好感在细节里慢慢积累。',
    points: [
      '早餐口味之争、搬家什等生活流场景，承担了全剧大部分轻松与喜剧节奏。',
      '被误读的短信成为新的导火索，苏念替姐姐留意，却把自己也卷进漩涡。',
      '翻出旧照片的一刻，家庭的记忆与温度被重新唤起。',
      '一场关于界限感的争执，让两人都开始思考家人之间该保持怎样的距离。',
    ],
  },
  {
    id: 'a3',
    title: '风波篇：误会累积到集中爆发',
    range: '第 10–14 集',
    lead: '外部变量闯入，所有被压下的问题一次性浮出水面。',
    points: [
      '周彦重回众人视线，一句轻描淡写的话让饭桌气氛降到冰点。',
      '断章取义的视频在亲友间流传，陆承第一次公开表态站在苏念一边。',
      '苏晚坦白隐瞒已久的病情，两条暗线交汇，此前细节全部有了新解释。',
      '旧仓库的对峙戏把旧账一页页翻开，也逼出陆承多年的愧疚。',
    ],
  },
  {
    id: 'a4',
    title: '大结局篇：把话说出口之后',
    range: '第 15–18 集',
    lead: '冲突落幕，角色在和解中完成各自的成长。',
    points: [
      '一场坦诚长谈让多集积攒的误会找到了出口。',
      '同一张餐桌、同样三个人，气氛却完全不同，形成温柔呼应。',
      '苏念面对离开与留下的抉择，“家人”的含义被重新定义。',
      '片尾回望镜头收束全剧，把开头的伏笔逐一回应，留下温暖余味。',
    ],
  },
];

export const watchSteps = [
  { id: 'w1', step: '1', title: '先看剧情简介与角色关系', desc: '进入首页后先读“剧情速览”和“角色关系”，3 分钟理解人物动机，追剧时不容易被反转绕晕。' },
  { id: 'w2', step: '2', title: '按篇章顺序看全集', desc: '剧集分为相遇、同住、风波、大结局四个篇章，建议按顺序观看，情绪与伏笔才能连成完整逻辑。' },
  { id: 'w3', step: '3', title: '时间紧就跳着看名场面', desc: '只想快速回味，可在“精彩名场面”里直接定位高能桥段，再回到对应集数补全前后上下文。' },
  { id: 'w4', step: '4', title: '一口气看到大结局', desc: '全剧单集时长较短，安排一整段空闲时间从第 1 集连看到第 18 集，是体验反转最完整的方式。' },
];

export const reviews: ReviewItem[] = [
  { id: 'r1', user: '追更的小鱼', badge: '一口气看完', text: '本来只想随便点开一集，结果直接连看到大结局。节奏真的快，每集结尾都留着钩子，属于很难中途停下的那种。' },
  { id: 'r2', user: '晚风与茶', badge: '细节党', text: '前面觉得姐夫太高冷，看到中段才发现前面埋了好多细节。回头二刷，很多当时的台词其实都是在铺垫。' },
  { id: 'r3', user: '周末剧场', badge: '完整版', text: '最喜欢的是没有为了爽而爽，误会解开之后还愿意花篇幅讲和解。姐姐那条线看哭了，处理得挺克制。' },
  { id: 'r4', user: '一只栗子', badge: '大结局', text: '大结局的餐桌戏和第一集呼应得太妙了。同样三个人、同样一顿饭，气氛完全不一样，细节真的到位。' },
  { id: 'r5', user: '追剧搭子', badge: '短剧免费', text: '单集时长对通勤党很友好，午休能看两集。看到第 12 集坦白那场戏，直接在公司楼下哭出来。' },
  { id: 'r6', user: '荔枝汽水', badge: '角色控', text: '陈姨是我最喜欢的角色，紧张的时候她端一碗汤出来，整个氛围就软下来了。生活感拉满。' },
];

export const faqs: FaqItem[] = [
  { id: 'f1', q: '《漂亮的小姨子》一共有多少集？讲的是什么？', a: '本页按相遇、同住、风波、大结局四个篇章整理了共 18 集的可浏览导览，核心是一段围绕亲情、误会与成长展开的家庭情感故事。每集单集时长较短，适合按篇章顺序连续观看。' },
  { id: 'f2', q: '想了解完整版和大结局，应该先看哪个部分？', a: '建议先看“剧情速览”和“角色关系”建立人物认知，再按篇章顺序浏览“全集分集导览”。如果只想快速了解结局走向，可先看“剧情篇章”里的大结局篇，再回到对应集数补全上下文。' },
  { id: 'f3', q: '如何实现短剧免费与一口气看完的体验？', a: '本站为内容导览页，不提供账号或在线播放。想获得“一口气看完”的连贯体验，建议预留一整段空闲时间，按第 1 集到大结局的顺序连续浏览，避免中间隔太久遗忘伏笔。' },
  { id: 'f4', q: '剧里的反转多吗？容易被绕晕吗？', a: '反转主要集中在中后段，且多数在前面的日常细节里埋了铺垫。观看时留意角色反复提到的旧事、被小心收起的物品等细节，跟着“剧情篇章”的时间线走，一般不会迷路。' },
  { id: 'f5', q: '“精彩名场面”里的片段需要单独找来看吗？', a: '不需要。名场面只是帮你在导览里快速定位高能桥段，建议看完对应时段后，再回到分集导览补全前后情节，这样既能看爽点，也不会漏掉关键信息。' },
  { id: 'f6', q: '页面上的分集介绍是剧情完整剧透吗？', a: '页面提供的是用于浏览与追更的看点导览，侧重于篇章走向与情绪节点，尽量保留观看趣味，并非逐句复述台词。若在意剧透，建议先按篇章顺序浏览，再看“剧情篇章”中的细节说明。' },
];

export const relatedItems: RelatedItem[] = [
  {
    id: 'd1',
    title: '姐姐的秘密',
    genre: '家庭情感',
    episodes: '20 集',
    blurb: '同样以家庭为切入口，围绕一段被隐瞒的往事展开，反转集中在后段。',
    poster:
      'https://readdy.ai/api/search-image?query=Elegant%20short%20drama%20poster%20with%20warm%20crimson%20and%20cream%20palette%2C%20softly%20blurred%20Chinese%20living%20room%20background%2C%20subtle%20gold%20light%20accents%2C%20minimal%20cinematic%20composition%2C%20moody%20editorial%20atmosphere&width=600&height=800&seq=drama-related-sister&orientation=portrait',
  },
  {
    id: 'd2',
    title: '同住的那一年',
    genre: '都市生活',
    episodes: '24 集',
    blurb: '轻松治愈的群像日常，聚焦室友之间的磨合、边界与相互扶持。',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20short%20drama%20poster%20with%20soft%20amber%20and%20beige%20palette%2C%20sunlit%20apartment%20window%20blurred%20background%2C%20clean%20cinematic%20composition%2C%20cozy%20editorial%20atmosphere&width=600&height=800&seq=drama-related-cohabit&orientation=portrait',
  },
  {
    id: 'd3',
    title: '旧账',
    genre: '悬疑情感',
    episodes: '18 集',
    blurb: '以一场多年后的重逢为起点，把旧日恩怨一层层揭开，节奏偏紧张。',
    poster:
      'https://readdy.ai/api/search-image?query=Moody%20short%20drama%20poster%20with%20deep%20green%20and%20warm%20charcoal%20palette%2C%20dim%20warehouse%20light%20blurred%20background%2C%20dramatic%20minimal%20cinematic%20composition%2C%20editorial%20atmosphere&width=600&height=800&seq=drama-related-olddebt&orientation=portrait',
  },
  {
    id: 'd4',
    title: '巷口的烟火',
    genre: '温情治愈',
    episodes: '26 集',
    blurb: '邻里之间的琐碎日常，用一餐一饭讲清楚人与人之间最朴素的善意。',
    poster:
      'https://readdy.ai/api/search-image?query=Cozy%20warm%20short%20drama%20poster%20with%20honey%20gold%20and%20cream%20palette%2C%20softly%20blurred%20old%20neighborhood%20alley%20background%2C%20gentle%20cinematic%20composition%2C%20nostalgic%20editorial%20atmosphere&width=600&height=800&seq=drama-related-neighbor&orientation=portrait',
  },
];

export const navLinks = [
  { id: 'intro', label: '剧情速览' },
  { id: 'cast', label: '角色关系' },
  { id: 'episodes', label: '全集导览' },
  { id: 'highlights', label: '名场面' },
  { id: 'plot', label: '剧情篇章' },
  { id: 'guide', label: '追更指南' },
  { id: 'reviews', label: '观众热议' },
  { id: 'faq', label: '常见问题' },
  { id: 'related', label: '相关推荐' },
];

export const marqueeItems = [
  '全集已上线 · 可直接一口气看完',
  '大结局篇 · 第 18 集 片尾回望',
  '第 12 集 姐姐的坦白 讨论度最高',
  '四篇章导览 · 相遇 / 同住 / 风波 / 大结局',
  '单集 2–4 分钟 · 适合碎片时间追更',
];